import React from 'react';
import { Trans } from 'react-i18next';
import { USERS, makeUserUrl } from 'src/routes/routes';
import { fullName } from 'src/utils/data/user';

export const makeBreadcrumbs = user => [
  {
    id: 1,
    text: <Trans>USERS</Trans>,
    link: USERS,
  },
  {
    id: 2,
    text: (user.id && fullName(user)) || <Trans>USER_NEW</Trans>,
    link: makeUserUrl(user.id || 'new'),
  },
];

export const makeTabs = user => [
  {
    id: 1,
    text: <Trans>EDIT</Trans>,
    link: makeUserUrl(user.id),
  },
  {
    id: 2,
    text: <Trans>SIGN_IN_LOG</Trans>,
    link: makeUserUrl(user.id),
  },
  {
    id: 3,
    text: <Trans>ACTIVITY_LOG</Trans>,
    link: null,
  },
];
